import { Component, OnInit,ViewChild } from '@angular/core';
import { ContainerTypeService } from 'app/shared/services/container-type.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'ngx-container-type',
  templateUrl: './container-type.component.html',
  styleUrls: ['./container-type.component.scss']
})
export class ContainerTypeComponent implements OnInit {

  displayedColumns: string[] = ['ContainerType', 'CreatedBy','Action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  containerType : string;
  containerTypeList : any;

  constructor(
              private containerTypeService : ContainerTypeService, 
              private route : ActivatedRoute, 
              private dialogService : DialogService,
              private authService: AuthService,
              private router : Router, 
              private toastr: ToastrService,
              private themeService: NbThemeService,
              public dialogRef: MatDialogRef<ContainerTypeComponent>
             ) { }

  ngOnInit() {

    this.getAllContainerType();

      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
          });
		  
    
  }

 

    onClose(){
      this.dialogRef.close();
     }


    getAllContainerType(){
    this.containerTypeService.getAll()
     .subscribe(
        (data) => {
                  this.containerTypeList = data;
                  this.dataSource = new  MatTableDataSource (this.containerTypeList);  
                  this.dataSource.paginator = this.paginator;      
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  

       
       
     }
   
     addContainerTypeBtnClick(){
    
        if (this.containerType){
          const formData = {
            containerType : this.containerType,
            createdBy : this.authService.getUserLoggedIn()
          }
    
            this.containerTypeService.create(formData)
              .subscribe(
                (res) => {
    
                  if(res.success === 0){
                    this.toastr.error(res.message, 'warning');
                  }else if(res.success === 1){
                    this.toastr.success('Record created successfully', 'Success');
                    this.getAllContainerType();
                    this.containerType = null;
                  }
                             
                },
                (err) => {
                  this.toastr.error('Failed to add item category', 'Failure');
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                },
              )
              
        }else {  
            this.toastr.warning('Required Fields cannot be empty or invalid.', 'Error Message');
        }
    
    
      }





     deleteButtonClick(id : string){
      this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.containerTypeService.delete(id)
        .subscribe(
          (res) => {
                      this.toastr.success('Deleted successfully','Success');
                      this.getAllContainerType();    
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete record','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
  }



   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }



}
